<template>
  <div class="survey-answers">
    <v-dialog
      v-model="isVisible"
      content-class="survey-answers__dialog"
      max-width="780"
      scrollable
      transition="dialog-transition"
    >
      <v-card class="survey-answers__card">
        <v-card-title
          class="survey-answers__title headline"
          primary-title
        >
          SURVEY ANSWERS
          <v-btn icon large color="primary" @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pb-0">
          <div v-if="answers.length"
            class="survey-answers__questions"
          >
            <v-slide-x-transition group mode="out-in">
              <question-container
                v-for="question in answers[currentIndex].questions"
                :key="question.id"
                :index="question.details.display_number"
                :title="question.title"
                :uptitle="question.metatitle"
                :description="question.description"
              >
                <component
                  :is="questionComponentType(question.type)"
                  :id="question.id"
                  :parameters="parametersOf(question)"
                  disabled
                />
              </question-container>
            </v-slide-x-transition>
          </div>
        </v-card-text>

        <v-card-actions class="survey-answers__actions">
          <v-btn
            class="white--text fw-400"
            :disabled="currentIndex === 0"
            color="blue"
            large
            min-width="234"
            @click="currentIndex -= 1;"
          >
            PREV
          </v-btn>
          <v-btn
            class="white--text fw-400"
            :disabled="currentIndex === answers.length - 1"
            color="blue"
            large
            min-width="234"
            @click="currentIndex += 1"
          >
            NEXT
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import QuestionContainer from '@/components/Survey/QuestionContainer.vue';
import QuestionSelect from '@/components/Survey/QuestionSelect.vue';
import QuestionTipi from '@/components/Survey/QuestionTipi.vue';
import QuestionInput from '@/components/Survey/QuestionInput.vue';
import QuestionScale from '@/components/Survey/QuestionScale.vue';
import QuestionSort from '@/components/Survey/QuestionSort.vue';

const paramExtractors = {
  single_select: (question) => ({
    possibleAnswers: question.possible_answers,
    currentAnswer: question.answer.possible_answer_id,
  }),
  input: (question) => ({
    currentAnswer: question.answer.content,
  }),
  tipi: (question) => ({
    possibleAnswers: question.possible_answers,
    currentAnswer: question.answer.possible_answer_id,
  }),
  scale: (question) => ({
    possibleAnswers: question.possible_answers,
    details: question.details,
    currentAnswer: question.answer.content,
  }),
  order: (question) => ({
    possibleAnswers: question.possible_answers,
    currentAnswer: question.answer.possible_answer_ids,
  }),
  default: (question) => ({
    currentAnswer: question.answer,
  }),
};

export default {
  components: {
    QuestionContainer,
    QuestionSelect,
    QuestionTipi,
    QuestionInput,
    QuestionScale,
    QuestionSort,
  },

  props: {
    value: {
      type: Boolean,
      required: true,
    },

    answers: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      currentIndex: 0,
    };
  },

  computed: {
    isVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  methods: {
    closeModal() {
      this.$emit('input', false);
      this.currentIndex = 0;
    },

    questionComponentType(type) {
      switch (type) {
        case 'single_select':
          return 'QuestionSelect';
        case 'tipi':
          return 'QuestionTipi';
        case 'scale':
          return 'QuestionScale';
        case 'order':
          return 'QuestionSort';
        default:
          return 'QuestionInput';
      }
    },

    parametersOf(question) {
      const paramExtractor = paramExtractors[question.type] || paramExtractors.default;
      return paramExtractor(question);
    },
  },
};
</script>

<style lang="scss">
.survey-answers {
  &__dialog {
    overflow: inherit;
  }

  &__title {
    display: flex;
    justify-content: space-between;
    font-weight: 600 !important;
    font-size: 22px !important;
  }

  &__questions {
    margin-bottom: 0;
    margin-top: 8px;
  }

  &__actions {
    padding: 16px 24px 16px 24px;
    justify-content: space-between;
  }
}
</style>
